export default __webpack_public_path__ + "static/iPad-Mockup1-b508f9b5cf08c8cdc212a61252867dc5.png";